// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type FolderId from "../contract/FolderId";

export default function folderId(data: FolderId): FolderId {
    const result: FolderId = {
        __type: "FolderId:#Exchange",
        ...data,
    };
    
    return result;
}
